import { isDate } from 'moment'
import { BackendError } from '../domain/BackendError'
import { DateTimeString } from '../domain/DateTime'

/**
 * This is the base class for data fetched from the server.
 *
 * This class provides a isCurrent() method based on an entity specific
 * time-to-live (TTL) to check if the entity should be refetched.
 */

export class Entity<DataType extends object | null> {
    public static purgeMap = (map: object): object => {
        const newMap = {}
        for (const key in map) {
            if (map[key] && map[key].isCurrent()) {
                newMap[key] = map[key]
            }
        }

        return newMap
    }

    public static purge = (entity: Entity<any>): Entity<any> | null => (entity && entity.isCurrent() ? entity : null)

    public loading: boolean
    public loaded: DateTimeString | Date | null
    public error: BackendError | null
    public data: DataType | null
    public ttl: number

    constructor(data?: DataType, ttl?: number) {
        this.loading = !data
        this.loaded = data ? new Date() : null
        this.error = null
        this.data = data || null
        this.ttl = ttl || 60
    }

    public isCurrent = (): boolean => {
        if (!this.loaded || this.error) {
            return false
        }

        return isDate(this.loaded) && this.loaded.getTime() > new Date().getTime() - this.ttl * 1000
    }

    public setError = (error: BackendError | null): Entity<any> => {
        this.loading = false
        this.loaded = null
        this.error = error
        this.data = null

        return this
    }
}
